import React, { PropsWithChildren, useCallback } from 'react'
import { Link } from 'react-router'
import './index.scss'
import clsx from 'clsx'

interface LinkCardProps {
    path: string
    className?: string
    handleOnClick?: (event: React.MouseEvent) => void
    disabled?: boolean
    openInNewTab?: boolean
}

const LinkCard = (props: PropsWithChildren<LinkCardProps>) => {
    const { path, className, children, disabled, openInNewTab } = props

    const handleOnClick = useCallback(
        (event: React.MouseEvent) => {
            if (props.handleOnClick) {
                props.handleOnClick(event)
            }
        },
        [props.handleOnClick]
    )

    return disabled ? (
        <span className={clsx(className, 'link-card')}>{children}</span>
    ) : (
        <Link
            to={path}
            target={openInNewTab ? '_blank' : undefined}
            rel={openInNewTab ? 'noopener noreferrer' : undefined}
            className={clsx(className, 'link-card')}
            onClick={handleOnClick}
        >
            {children}
        </Link>
    )
}

export default LinkCard
